import React, { useMemo } from 'react';
import { useLoaderData, useSearchParams } from 'react-router-dom';

import { StorageProvider } from './StorageContext';

export const SearchParamsStorage = ({
  children,
  searchParams: schema,
  mergeScreenStateWithLoadData,
  disabledSchemaValidation,
}) => {
  const data = useLoaderData();
  let [searchParams, setSearchParams] = useSearchParams();

  const handleReset = () => {
    setSearchParams('');
  };

  const initialState = useMemo(() => {
    const searchParamsState = schema ? schema.parse(searchParams) : {};

    if (
      searchParamsState.ready === false &&
      mergeScreenStateWithLoadData &&
      data
    ) {
      return mergeScreenStateWithLoadData(searchParamsState, data);
    }
    return searchParamsState;
  }, [schema, searchParams, mergeScreenStateWithLoadData, data]);

  const screenErrors = useMemo(() => {
    return schema && !disabledSchemaValidation
      ? schema.validate(initialState)
      : [];
  }, [schema, initialState]);

  const handleIsEqual = (state) => {
    return schema.stringify(state) === schema.stringify(initialState);
  };

  const handleSave = (state) => {
    const stateString = schema.stringify(state);
    setSearchParams(stateString);
  };

  return (
    <StorageProvider
      state={initialState}
      errors={screenErrors}
      onSave={handleSave}
      onReset={handleReset}
      isEqual={handleIsEqual}
    >
      {children}
    </StorageProvider>
  );
};
